import Lightbox from './components/_lightbox.js';
new Lightbox();
